import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AdminPanelService} from '../../../data/admin-panel.service';
import {MiscSnackBarService} from '../../../../../../../../core/src/lib/misc/view/snackbar/misc-snackbar.service';
import {PricingMultiplication} from '../../../../project-calc/data/multiplication/pricing-multiplication';
import {PricingCategory} from '../../../../project-calc/data/pricing-category';

@Component({
  selector: 'app-multiplication-editor-dialog',
  templateUrl: './multiplication-editor-dialog.component.html',
  styleUrls: ['./multiplication-editor-dialog.component.scss']
})
export class MultiplicationEditorDialogComponent implements OnInit {
  catId: number
  headerTitle = 'New Multiplication';
  footerBtnString = 'Add'

  tempPricingMultiplication: PricingMultiplication;

  loadingSpinner: boolean;
  deleteLoadingSpinner: boolean;

  typeLoading = true;

  categories: PricingCategory[]
  applyToFields: string[]
  operations: string[]

  constructor(
    protected dialogRef: MatDialogRef<MultiplicationEditorDialogComponent>,
    protected adminPanelService: AdminPanelService,
    private miscSnackBarService: MiscSnackBarService,
    @Inject(MAT_DIALOG_DATA) private data: {
      multiplication: PricingMultiplication,
      categories: PricingCategory[],
      applyToFields: string[],
      operations: string[]
    }
  ) {
    this.tempPricingMultiplication = Object.assign({}, this.data.multiplication);
    this.categories = this.data.categories;
    this.applyToFields = this.data.applyToFields
    this.operations = this.data.operations;


    if (this.tempPricingMultiplication.id) {
      this.headerTitle = 'Edit Multiplication'
      this.footerBtnString = 'Save'
    }
  }

  ngOnInit(): void {
    this.typeLoading = false
  }

  saveSub() {
    this.loadingSpinner = true;

    if (this.tempPricingMultiplication.id) {
      this.adminPanelService.updateMultiplication(this.tempPricingMultiplication).subscribe(res => {
        this.dialogRef.close(res)
      }, () => {
        this.loadingSpinner = false
      })
    } else {
      this.adminPanelService.createMultiplication(this.tempPricingMultiplication).subscribe(res => {
        this.dialogRef.close(res)
      }, () => {
        this.loadingSpinner = false
      })
    }
  }


  closeDialog() {
    this.dialogRef.close('close-button');
  }

  deleteSub() {
    this.deleteLoadingSpinner = true
    this.adminPanelService.deleteMultiplication(this.tempPricingMultiplication.id).subscribe(() => {

      this.dialogRef.close('delete');
    }, () => {
      this.deleteLoadingSpinner = false
    })
  }


}
